<a [routerLink]="[link]" id="skipThisComment" (click)="clickListner()" [queryParamsHandling]="paramsHandling" class="skip">
  {{label}} <i *ngIf="icon" class="material-icons goto-portfolio">keyboard_arrow_right</i>
</a>